import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Button,
  Paper,
  Typography,
  Modal,
  Table,
  TableHead,
  TableContainer,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { Ayudantia, AyudantiaInvestigacionData, PlanificacionAyudantia, VoidPlanificacionAyudantia } from "../../interfaces/AYUDANTIAS/Ayudantia";
import { SolicitudesAyudTable } from "./SolicitudesAyudTable";
import { useNavigate } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { useAppSelector } from "../../redux/hooks";
import { PeriodoAcademico, VoidPeriodoAcademico } from "../../interfaces/SAAC/PeriodoAcademico";
import AcademicoService from "../../services/AcademicoService";
import AyudantiaService from "../../services/AyudantiaService";
import { PantallaCargaPage } from "../../pages/Modulos/PantallaCargaPage";
import { PlanificacionAyudantias } from "./PlanificacionAyudantias";
//import { useMockIsAuthenticated } from "../../pages/Home/AuthContext";


const academicoService = new AcademicoService();
const ayudantiaService = new AyudantiaService();
export const SolicitudesAyudantiasDelegado: React.FC<{}> = () => {

  const [solictudesDelegado, setSolicitudesDelegado] = useState<Array<AyudantiaInvestigacionData>>([]);


  const [solictudesDelegadoPend, setSolicitudesDelegadoPend] = useState<Array<AyudantiaInvestigacionData>>([]);
  const [solictudesDelegadoAp, setSolicitudesDelegadoAp] = useState<Array<AyudantiaInvestigacionData>>([]);
  const [solictudesDelegadoRec, setSolicitudesDelegadoRec] = useState<Array<AyudantiaInvestigacionData>>([]);
  const [solictudesDelegadoImp, setSolicitudesDelegadoImp] = useState<Array<AyudantiaInvestigacionData>>([]);

  const [solictudesDirectivo, setSolicitudesDirectivo] = useState<Array<AyudantiaInvestigacionData>>([]);
  const isAuthenticated = useIsAuthenticated();
  //const isAuthenticated = useMockIsAuthenticated();
  const token = useAppSelector((state) => state.authReducer.token);
  const [periodoActivo, setPeriodoActivo] = useState<PeriodoAcademico>(VoidPeriodoAcademico());
  const { userData } = useAppSelector((state) => state.authReducer);

  const[readySolPendientes, setReadySolPendientes] = useState<boolean>(false);
  const[readySolAprobadas, setReadySolAprobadas] = useState<boolean>(false);
  const[readySolRechazadas, setReadySolRechazadas] = useState<boolean>(false);
  const[readySolImpedimentos, setReadySolImpedimentos] = useState<boolean>(false);
  const[readyResumen, setReadyResumen] = useState<boolean>(false);

  const[resumenHoras, setResumenHoras] = useState<PlanificacionAyudantia>(VoidPlanificacionAyudantia());


  const [solicitudes, setSolicitudes] = useState<Ayudantia[]>([
    {
      idayudantia: 1,
      nombreproyecto: "Proyecto A",
      nombreayudante: "Estudiante 1",
      matricula: "201813417",
      nombreInvestigador: "Investigador 1",
      fechaSolicitud: new Date(),
      estado: "A",
      estudianteCumple: "S",
      horas: 5,
    },
    {
      idayudantia: 2,
      nombreproyecto: "Proyecto B",
      nombreayudante: "Estudiante 2",
      matricula: "201813418",
      nombreInvestigador: "Investigador 2",
      fechaSolicitud: new Date(),
      estado: "P",
      estudianteCumple: "N",
      horas: 10,
    },
    {
      idayudantia: 3,
      nombreproyecto: "Proyecto C",
      nombreayudante: "Estudiante 3",
      matricula: "201813419",
      nombreInvestigador: "Investigador 3",
      fechaSolicitud: new Date(),
      estado: "R",
      estudianteCumple: "S",
      horas: 5,
    },
    {
      idayudantia: 4,
      nombreproyecto: "Proyecto D",
      nombreayudante: "Estudiante 4",
      matricula: "201813419",
      nombreInvestigador: "Investigador 4",
      fechaSolicitud: new Date(),
      estado: "A",
      estudianteCumple: "S",
      horas: 10,
    },
    {
      idayudantia: 5,
      nombreproyecto: "Proyecto E",
      nombreayudante: "Estudiante 5",
      matricula: "201813419",
      nombreInvestigador: "Investigador 5",
      fechaSolicitud: new Date(),
      estado: "P",
      estudianteCumple: "S",
      horas: 5,
    },
    {
      idayudantia: 6,
      nombreproyecto: "Proyecto F",
      nombreayudante: "Estudiante 6",
      matricula: "201813419",
      nombreInvestigador: "Investigador 6",
      fechaSolicitud: new Date(),
      estado: "P",
      estudianteCumple: "N",
      horas: 10,
    },
  ]);


  const handleReadyAprobadas = () =>{
    setReadySolAprobadas(false);
  }

  const handleReadyPendientes = () =>{
    setReadySolPendientes(false);
  }

  const handleReadyRechazadas = () => {
    setReadySolRechazadas(false);
  }


  //let tipoPersonaDelegado = userData.rolesInvestigacion.find(x=>x.idrol == 151) ? 'S':'';
  let tipoPersonaDelegado = userData.unidadesDirectivo.tipoPersona!=null ? userData.unidadesDirectivo.tipoPersona : "";
  

  useEffect(()=>{
    if (isAuthenticated ) {
      GetSolicitudesDelegadoPendientes(tipoPersonaDelegado);
    }

  },[token,isAuthenticated, readySolPendientes])

  useEffect(()=>{
    if (isAuthenticated ) { 
      GetSolicitudesDelegadoAprobadas(tipoPersonaDelegado);
    }

  },[token,isAuthenticated, readySolAprobadas])

  useEffect(()=>{
    if (isAuthenticated ) { 
      GetSolicitudesDelegadoRechazadas(tipoPersonaDelegado);
    }
  },[token,isAuthenticated, readySolRechazadas])

  useEffect(()=>{
    if (isAuthenticated ) { 
      GetSolicitudesImpedimentos(tipoPersonaDelegado);
    }
  },[token,isAuthenticated, readySolImpedimentos])

  useEffect(()=>{
    if (isAuthenticated ) {
      GetHorasResumenPlanificacion();
    }
  },[token,isAuthenticated, readySolAprobadas, readySolPendientes])

  const GetSolicitudesImpedimentos = async (tipoPersona: string) => {
    try{
      await ayudantiaService.GetSolicitudesAyudantiasImpedimentoByTipoPersona(token,tipoPersona)
      .then((data)=>{
        if(data.status.isSuccessfully){
          setSolicitudesDelegadoImp(data.listData)
          setReadySolImpedimentos(true);
        }else{
          setSolicitudesDelegadoImp([])
          setReadySolImpedimentos(true);
        }
      })
    }
    catch(error){
      console.error('Error:', error);
    }

  }

  const GetSolicitudesDelegadoPendientes = async (tipoPersona : string) => {
    try {
      await ayudantiaService.GetSolicitudesAyudantiasPendientesByTipoPersona(token, tipoPersona)
      .then((data) => {

        if (data.status.isSuccessfully) {
          setSolicitudesDelegadoPend(data.listData);
          setReadySolPendientes(true);
        } else {
          setSolicitudesDelegadoPend([]);
          setReadySolPendientes(true);
        }
      })
      .catch((error) => console.error(error));
      } catch (error) {
          console.error('Error:', error);
      }
  };

  const GetSolicitudesDelegadoAprobadas = async (tipoPersona : string) => {
    try {
      await ayudantiaService.GetSolicitudesAyudantiasAprobadasByTipoPersona(token, tipoPersona)
      .then((data) => {
        if (data.status.isSuccessfully) {
          setSolicitudesDelegadoAp(data.listData);
          setReadySolAprobadas(true);
        } else {
          setSolicitudesDelegadoAp([]);
          setReadySolAprobadas(true);
        }
      })
      .catch((error) => console.error(error));
      } catch (error) {
          console.error('Error:', error);
      }
  };
  

  const GetSolicitudesDelegadoRechazadas = async (tipoPersona : string) => {
    try {
      await ayudantiaService.GetSolicitudesAyudantiasRechazadasByTipoPersona(token, tipoPersona)
      .then((data) => {
        if (data.status.isSuccessfully) {
          setSolicitudesDelegadoRec(data.listData);
          setReadySolRechazadas(true);
        } else {
          setSolicitudesDelegadoRec([]);
          setReadySolRechazadas(true);
        }
      })
      .catch((error) => console.error(error));
      } catch (error) {
          console.error('Error:', error);
      }
  };

  const GetHorasResumenPlanificacion = async()=>{
    try{
      await ayudantiaService.GetResumenAsignacionAyudantias(token)
      .then((data)=>{
        if(data.status.isSuccessfully){
          setResumenHoras(data.data);
          setReadyResumen(true);
        }
         
        else{
          setResumenHoras(VoidPlanificacionAyudantia())
        }
          
      })

    }catch(error){
      console.error('Error',error)
    }
  }



  
  return (
    
    <Container maxWidth="xl" sx={{ padding: "20px", width:'95%' }}>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }}
      >
        SOLICITUDES DE AYUDANTÍAS
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
        <Box
          sx={{
            height: 4,
            width: "100px",
            bgcolor: "primary.main",
            borderRadius: "2px",
          }}
        />
      </Box>

      {
        
        <Container maxWidth='xl'>


          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <PlanificacionAyudantias ready={readyResumen} planificacion={resumenHoras} />
          </Box>


          <Paper  elevation={3} sx={{ padding: 2, marginBottom: 3}}>
            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }} gutterBottom>
              Solicitudes pendientes
            </Typography>
            {
              readySolPendientes ?
              <SolicitudesAyudTable sonPendientes={true} showImpedimento={false} showRechazarTodo={true} tipoPersona="S"
              solicitudes={ solictudesDelegadoPend} onActionPendientes={handleReadyPendientes} onActionAprobadas={handleReadyAprobadas} onActionRechazadas={handleReadyRechazadas} rowsPerPage={[5, 10, 25, 100]}/>
              :
              <PantallaCargaPage />
            
            }
            
          </Paper>

          <Paper  elevation={3} sx={{ padding: 2, marginBottom: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }} gutterBottom>
              Solicitudes aprobadas
            </Typography>
            {
              readySolAprobadas ?
              <SolicitudesAyudTable sonPendientes={false} rowsPerPage={[5, 10, 25, 100]} showImpedimento={false} showRechazarTodo={false}
              solicitudes={ solictudesDelegadoAp } onActionAprobadas={handleReadyAprobadas} onActionPendientes={handleReadyPendientes} tipoPersona="S"
              />
              :
              <PantallaCargaPage />

            }
            
          </Paper>

          <Paper  elevation={3} sx={{ padding: 2, marginBottom: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }} gutterBottom>
              Solicitudes Rechazadas
            </Typography>
            {
              readySolRechazadas ? 
              <SolicitudesAyudTable sonPendientes={false} rowsPerPage={[5, 10, 25, 100]} showImpedimento={false} showRechazarTodo={false} tipoPersona="S"
                solicitudes={ solictudesDelegadoRec } onActionPendientes={handleReadyPendientes} onActionRechazadas={handleReadyRechazadas}
              />
              :
              <PantallaCargaPage />
            }
            
          </Paper>
          

          <Paper  elevation={3} sx={{ padding: 2, marginBottom: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }} gutterBottom>
              Solicitudes con impedimentos
            </Typography>
            {
              readySolImpedimentos ? 
              <SolicitudesAyudTable sonPendientes={false} rowsPerPage={[5, 10, 25, 100]} showImpedimento={true} showRechazarTodo={false} tipoPersona="S"
                solicitudes={ solictudesDelegadoImp }
              />
              :
              <PantallaCargaPage />
            }
            
          </Paper>

          
        </Container>
      }
      {/* {[
        { title: "APROBADAS", solicitudes: solicitudes.filter((s) => s.estado === "A"), acciones: accionesAprobadas },
        { title: "PENDIENTES", solicitudes: solicitudes.filter((s) => s.estado === "P" && s.estudianteCumple === "S"), acciones: accionesPendientes },
        { title: "RECHAZADAS", solicitudes: solicitudes.filter((s) => s.estado === "R"), acciones: accionesRechazadas },
        { title: "ESTUDIANTES QUE NO CUMPLEN LOS REQUISITOS", solicitudes: solicitudes.filter((s) => s.estudianteCumple === "N"), acciones: accionesEstudianteNoCumple },
      ].map((section, index) => (
        <Paper key={index} elevation={3} sx={{ padding: 2, marginBottom: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }} gutterBottom>
            {section.title}
          </Typography>
          <SolicitudesAyudTable
            solicitudes={section.solicitudes}
            acciones={section.acciones}
          />
        </Paper>
      ))}

      <Modal
        open={modalOpen}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography
            id="modal-title"
            sx={{ fontWeight: "normal", fontSize: "18px", mb: 2 }}
          >
            Detalle
          </Typography>
          <Typography
            id="modal-description"
            sx={{ mt: 2, textAlign: "justify", fontWeight: "normal" }}
          >
            {modalContent}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 3,
            }}
          >
            <Button onClick={closeModal} variant="outlined">
              Cerrar
            </Button>
          </Box>
        </Box>
      </Modal> */}
    </Container>
    
  );
};
